var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pa-16"},[_c('v-container',[_c('p',{staticClass:"text-h5 mb-10"},[_vm._v(" "+_vm._s(_vm.$t('COMMON.COPYWRITING.CANT_FIND_THIS_PAGE'))+" ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }